/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {findIndex, assign} from 'lodash';

import {useDispatch, useSelector} from "react-redux";
import {getTeam, setCurrentPage, setOrder, setSelectedId} from "./teamSlice";

import TableWithPaging from '../../../common/components/TableWithPaging';
import {APP_COLORS} from "../../../common/Constants";
import CheckBox from "../../../common/components/CheckBox";

const TeamTable = (props) => {
    const dispatch = useDispatch();
    const teamState = useSelector((state) => state.team);

    useEffect(() => {
        // When open dialog, we clear state.
        dispatch(getTeam());
    }, [props.lastReload, dispatch]);

    const createHeader = (row) => {
        return [
            {
                id: 1,
                name: '',
                property: 'id',
                sortable: false,
                formatted: true,
                formatBy: (row) => {
                    // let image = tbdBrainLightningIcon;
                    return <div>
                        <CheckBox
                            innerState
                            onChange={value =>
                                dispatch(setSelectedId({
                                    id: row.id,
                                    isChecked: value
                                }))
                            }
                        />
                    </div>
                }
            },
            {
                id: 2,
                name: 'Given Name',
                property: 'profile.givenName',
                sortable: true,
                formatted: true,
                formatBy: (row, header) => (row.profile ? row.profile.givenName : ''),
            },
            {
                id: 3,
                name: 'Surname',
                property: 'profile.surName',
                sortable: true,
                formatted: true,
                formatBy: (row, header) => (row.profile ? row.profile.surName : ''),
            },
            {
                id: 4,
                name: 'Email',
                property: 'email',
                sortable: true,
                formatted: false,
            },
            {
                id: 5,
                name: 'Role',
                property: 'roles',
                sortable: true,
                formatted: true,
                formatBy: (row) => {
                    const role = row.roles && row.roles.length === 1 ? row.roles[0] : '';
                    if (role) {
                        if (role === 'OWNER') {
                            return <span style={{
                                fontWeight: 'bold',
                                // color: APP_COLORS.yellow
                            }}>{role}</span>
                        }
                    }
                    return <span>{role}</span>
                }
            },
            {
                id: 6,
                name: 'Status ',
                property: 'statusId',
                sortable: true,
                formatted: true,
                formatBy: (row) => {
                    if (row.statusId === 'ACTIVE') {
                        return <span style={{color: APP_COLORS.green}}>{row.statusId}</span>
                    }
                    if (row.statusId === 'DISABLED') {
                        return <span style={{color: APP_COLORS.red}}>{row.statusId}</span>
                    }
                    return <span>{row.statusId}</span>
                }
            },
        ];
    };

    const headersUtil = (hds, hd, sortOrder) => {
        const _headers = hds.map(hc => assign(hc, {sortOrder: null}));
        _headers.splice(
            findIndex(hds, {id: hd.id}),
            1,
            assign({}, hd, {
                sortOrder: sortOrder,
            })
        );
        return _headers;
    };

    const handleSort = (header) => {
        if (!header.sortable) return;
        let _sortOrder;
        if (!header.sortOrder) _sortOrder = 'ASC';
        if (header.sortOrder === 'ASC') _sortOrder = 'DESC';
        if (header.sortOrder === 'DESC') _sortOrder = 'ASC';
        setHeader(headersUtil(headers, header, _sortOrder));
        dispatch(setOrder({by: header.property, direction: _sortOrder}));
        onSelectPage(
            1,
            {
                [header.property]: _sortOrder.toLowerCase()
            }
        );
    };

    const onSelectPage = (page) => {
        dispatch(setCurrentPage(page));
        dispatch(getTeam());
    };

    const [headers, setHeader] = useState(createHeader().map(hc =>
        assign(hc, {
            sortOrder: null,
            handleSort: value => handleSort(value),
        })));

    return (
        <div>
            <TableWithPaging
                id={'source-table-with-paging'}
                headers={headers}
                rows={teamState.team}
                countOfResults={teamState.totalRecords}
                resultsPerPage={teamState.pageSize}
                currentPage={teamState.currentPage}
                onSelectPage={(page) => onSelectPage(page)}
            />
        </div>
    )
};


TeamTable.propTypes = {
    team: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            type: PropTypes.string
        })
    ),
    handleSearch: PropTypes.func,
};

TeamTable.defaultProps = {
    style: {},
    className: '',
    labelStyle: {},
    team: []
};

export default TeamTable;
